import React from 'react';
import './Loading.scss';

const Loading = () => (
  <div className="text-center" id="loading-wrapper">
    <h1>Loading...</h1>
  </div>
);

export default Loading;
